'use client';

import {cn} from '../../lib/utils';

import type * as React from 'react';

function Breadcrumb({className, ...props}: React.ComponentProps<'nav'>) {
  return (
    <nav aria-label="breadcrumb" data-slot="breadcrumb" className={cn(className)} {...props} />
  );
}

function BreadcrumbList({className, ...props}: React.ComponentProps<'ol'>) {
  return (
    <ol
      data-slot="breadcrumb-list"
      className={cn('flex flex-wrap items-center gap-1.5 wrap-break-word text-sm', className)}
      {...props}
    />
  );
}

function BreadcrumbItem({className, ...props}: React.ComponentProps<'li'>) {
  return (
    <li
      data-slot="breadcrumb-item"
      className={cn('inline-flex items-center gap-1.5', className)}
      {...props}
    />
  );
}

function BreadcrumbLink({
  className,
  children,
  ...props
}: React.ComponentProps<'a'> & {children: React.ReactNode}) {
  return (
    <a
      data-slot="breadcrumb-link"
      className={cn(
        'cursor-pointer text-sm font-semibold text-fg-quaternary hover:text-fg-secondary transition-colors duration-200 shrink-0 whitespace-nowrap',
        className
      )}
      {...props}
    >
      {children}
    </a>
  );
}

function BreadcrumbPage({
  className,
  children,
  ...props
}: React.ComponentProps<'span'> & {children: React.ReactNode}) {
  return (
    <span
      aria-current="page"
      data-slot="breadcrumb-page"
      className={cn(
        'shrink-0 whitespace-nowrap text-sm font-semibold text-brand-accent',
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

function BreadcrumbSeparator({className, children, ...props}: React.ComponentProps<'li'>) {
  return (
    <li
      aria-hidden="true"
      data-slot="breadcrumb-separator"
      className={cn('text-fg-quaternary shrink-0', className)}
      {...props}
    >
      {children}
    </li>
  );
}

export {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
};
